"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_card_requirement = (0, vue_1.resolveComponent)("card-requirement");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        class: (0, vue_1.normalizeClass)(_ctx.getClasses)
    }, [
        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.requirements, (req, idx) => {
            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", { key: idx }, [
                (0, vue_1.createVNode)(_component_card_requirement, {
                    requirement: req,
                    leftMargin: _ctx.indentRight[idx]
                }, null, 8, ["requirement", "leftMargin"])
            ]));
        }), 128))
    ], 2));
}
